const getters = {
    roleList: state => state.info.roleList,
    province: state => state.info.province,
    city: state => state.info.city,
    district: state => state.info.district,
};
export default getters;